module.exports = __webpack_public_path__ + "static/media/Cabs2.0-225-25-A.f0e8819c.png";